import type { CSSProperties } from 'react';

import { type MRT_CompatibleTheme } from '../lib/mrt-theme';

export function resolveThemeStyle(
    style: ((theme: MRT_CompatibleTheme) => CSSProperties) | CSSProperties | undefined,
    theme: MRT_CompatibleTheme,
): CSSProperties | undefined {
    if (!style) return undefined;
    return typeof style === 'function' ? style(theme) : style;
}

export function mergeCssVars(vars?: Record<string, number | string | undefined>): CSSProperties | undefined {
    if (!vars) return undefined;
    return vars as CSSProperties;
}
